import {boTreeDataLoading, custTypeDataLoading, ecTreeDataLoading} from "@/pages/policy/ProductPolicyApply/data";
import {WdiPanel} from "@/components/WdiControls/WdiPanel";
import {FieldProps, WdiCardTitle, WdiInput} from "@/components/WdiControls";
import {Enum} from "@/enums/system";
import {Checkbox, Col, DatePicker, Form, Input, Row} from "antd";
import {WdiSelect, WdiTreeSelect} from "@/components/WdiControls/WdiSelect";
import React, {useEffect, useState} from "react";
import {WdiFileUpload} from "@/components/WdiControls/WdiFileUpload";
import {OpenModeEnum} from "@/pages/policy/ProductPolicyApply/components/apply";
import {BOHQ} from "@/services/mdm/bohq";
import {OaProgramSelectApp} from "@/pages/policy/ProductPolicyApply/components/OaProgramSelectApp";
import {WdiEditor} from "@/components/WdiControls/WdiEditor";
import {DataOptions} from "@/services/basic/metadata";

type ProductPolicyHeaderProps = {
  formRef: React.MutableRefObject<any>;
  openMode: OpenModeEnum;
  setEditorRef?:(ref:any)=>void;
};

const ProductPolicyBasicApplyPanel: React.FC<ProductPolicyHeaderProps> = (props: ProductPolicyHeaderProps) => {

  const [editorRef,setEditorRef] = useState<any>();

  useEffect(()=>{
    props.setEditorRef?.(editorRef)
  },[editorRef])


  return (<>
    <WdiPanel collapsed={true} title={<WdiCardTitle iconType={Enum.IconType.BASE_INFO} title={'基本信息'}/>}>
      <Row gutter={[16, 0]}>
        <Col className="gutter-row" span={16} hidden={true} key={"productPolicyId"}>
          <Form.Item name="productPolicyId" label="id">
            <WdiInput/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={16} hidden={true} key={"policyCode"}>
          <Form.Item name="policyCode" label="id">
            <WdiInput/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={4} key="policyName">
          <Form.Item name="policyName" label="政策名称" rules={[{required: true, message: '政策名称不能为空!'}]}>
            <Input/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={4} key="bohqId">
          <Form.Item
            name="bohqId"
            label="预算归属"
            rules={[{required: true, message: '预算归属不能为空!'}]}
          >
            <WdiTreeSelect
              {...{
                disabled: props.openMode === OpenModeEnum.UPDATE_PARTLY,
                placeholder: '请选择预算归属',
                labelInValue: true,
                //defaultExpandKeys: expandKeysProductReachEx,
                dataLoading: async (params) => {
                  const response = await BOHQ.search({
                    isActive: true,
                    withPermissions: true,
                    bohqLevels: [
                      Enum.BOLevel.BO1,
                      Enum.BOLevel.BO2,
                    ].join(),
                    existLessRoot: true
                  });
                  const {treeData, dict} = FieldProps.TreeSelect.formatTreeData(
                    {
                      textField: 'bohqName',
                      valueField: 'bohqId',
                      id: 'bohqId',
                      pId: 'parentId',
                      level: 'bohqLevel',
                      disabledLevel: [0, 1],
                    },
                    response.data,
                  );
                  return {treeData, dict};
                },
              }}
            />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={4} key="bohqRebateTypeId">
          <Form.Item
            name="bohqRebateTypeId"
            label="返利预算归属方式"
            rules={[{required: true, message: '返利预算归属方式不能为空!'}]}
          >
            <WdiSelect
              {...{
                disabled: props.openMode === OpenModeEnum.UPDATE_PARTLY,
                placeholder: "请选择返利预算归属方式",
                showSearch: true,
                dataLoading: () => {
                  return DataOptions.search({typeGroup: 177}).then(responseReuslt => {
                    return responseReuslt?.data.map((item) => {
                      return {value: item.value, label: item.name}
                    })
                  });
                }
              }}/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={8} key="policyDate">
          <Form.Item name="policyDate" label="政策期间" rules={[{required: true, message: '政策期间不能为空!'}]}>
            <DatePicker.RangePicker format={'YYYY-MM-DD'}
                                    disabled={props.openMode === OpenModeEnum.UPDATE_PARTLY ? [true, false] : [false, false]}/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={4} key="boIds">
          <Form.Item name="boIds" label="使用部门范围" rules={[{required: true, message: '使用部门范围不能为空!'}]}>
            <WdiTreeSelect {...{
              disabled: props.openMode === OpenModeEnum.UPDATE_PARTLY,
              multiple: true,
              placeholder: "请选择使用部门范围",
              dataLoading: async () => boTreeDataLoading({
                isActive: true,
                boLevels: "0,1,2,3,4",
              }),
              onExSelect: (value: any, node: any, dict: any) => {
                const values = props.formRef.current?.getFieldValue("boIds");
                const rtv = FieldProps.TreeSelect.labeledValuesMeger(dict, values, {value});
                props.formRef.current?.setFieldsValue({
                  boIds: rtv
                });
              }
            }} />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={4} key="custTypeIds">
          <Form.Item
            name="custTypeIds"
            label="客户分类(不填即全部)"
          >
            <WdiTreeSelect {...{
              disabled: props.openMode === OpenModeEnum.UPDATE_PARTLY,
              multiple: true,
              placeholder: "客户分类(不填即全部)",
              dataLoading: async () => custTypeDataLoading({
                isActive: true,
                custTypeLevels: "1,2,3",
              }),
              onExSelect: (value: any, node: any, dict: any) => {
                const values = props.formRef.current?.getFieldValue("custTypeIds");
                const rtv = FieldProps.TreeSelect.labeledValuesMeger(dict, values, {value});
                props.formRef.current?.setFieldsValue({
                  custTypeIds: rtv
                });
              }
            }} />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={4} key="policyCategoryId">
          <Form.Item
            name="policyCategoryId"
            label="政策类别"
            rules={[{required: true, message: '政策类别不能为空!'}]}
          >
            <WdiSelect
              {...{
                disabled: props.openMode === OpenModeEnum.UPDATE_PARTLY,
                placeholder: "请选择政策类别",
                showSearch: true,
                dataLoading: () => {
                  return DataOptions.search({typeGroup: 175}).then(responseReuslt => {
                    return responseReuslt?.data.map((item) => {
                      return {value: item.value, label: item.name}
                    })
                  });
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={4} key="ecIds">
          <Form.Item name="ecIds" label="费用项" rules={[{required: true, message: '费用项不能为空!'}]}>
            <WdiTreeSelect
              {...{
                disabled: props.openMode === OpenModeEnum.UPDATE_PARTLY,
                multiple: false,
                placeholder: "请选择费用项",
                dataLoading: async () => ecTreeDataLoading({isActive: true, withPermissions: true}),
                onExSelect: (value: any, node: any, dict: any) => {
                  const values = props.formRef.current?.getFieldValue("ecIds");
                  const rtv = FieldProps.TreeSelect.labeledValuesMeger(dict, values, {value});
                  props.formRef.current?.setFieldsValue({
                    ecIds: rtv
                  });
                },
                onChange: (value)=>{
                  props.formRef.current?.setFieldsValue({'paymentMethod':undefined})
                }
              }} />
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={4} key="oaFormNo">
          <Form.Item name="oaForms" label="OA方案" rules={[{required: false, message: 'OA方案不能为空!'}]}>
            <OaProgramSelectApp/>
          </Form.Item>
        </Col>

        <Col className="gutter-row" span={4} key="isAutoAppend">
          <Form.Item name="isAutoAppend" label="追溯计算(已生成过返利则无效)" valuePropName="checked">
            <Checkbox disabled={props.openMode === OpenModeEnum.UPDATE_PARTLY}/>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 24]}>
        <Col className="gutter-row" span={16}>
          <Form.Item
            name="remark"
            label="政策说明"
          >
            <WdiEditor setRef={setEditorRef}/>
          </Form.Item>
        </Col>
        <Col className="gutter-row" span={8}>
          <Form.Item
            name="fileInfo"
            label="附件"
            valuePropName="fileList"
            getValueFromEvent={(e: any) => {
              return e.fileList || [];
            }}
          >
            <WdiFileUpload leftTopInfo="请选择文件并上传(单个文件不能超500M)" multiple={true}/>
          </Form.Item>
        </Col>
      </Row>
    </WdiPanel>
  </>)
}

export default ProductPolicyBasicApplyPanel;
